import breakpoints from './breakpoints'

const mq = breakpoints.reduce( (acc, cur) => ({...acc, ...cur}), {})

for (const [key,value] of Object.entries(mq)) {
	mq[key] = `@media (min-width: ${value}px)`
}

export default mq
